(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nt-scripts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nt-scroller')) {
    class NtScroller extends HTMLElement {
      connectedCallback() {
        if (!this.firstElementChild) { requestAnimationFrame(() => this.connectedCallback()); return; }
        this.track = this.querySelector('[data-nt-track]');
        this.prev = this.querySelector('[data-nt-prev]');
        this.next = this.querySelector('[data-nt-next]');
        if (!this.track) return;
        this.update = this.update.bind(this);
        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }
      go(direction) {
        const item = this.track.firstElementChild;
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('nt-scroller', NtScroller);
  }

  if (!customElements.get('nt-timeline')) {
    class NtTimeline extends HTMLElement {
      connectedCallback() {
        if (!this.querySelector("[data-nt-week]")) { requestAnimationFrame(() => this.connectedCallback()); return; }
        this.weeks = [...this.querySelectorAll('[data-nt-week]')];
        this.progress = this.querySelector('[data-nt-progress]');
        this.onScroll = this.onScroll.bind(this);
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        this.onScroll();
      }
      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
      }
      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const focus = window.innerHeight * 0.55;
          const box = this.getBoundingClientRect();
          const ratio = Math.min(1, Math.max(0, (focus - box.top) / box.height));
          if (this.progress) this.progress.style.height = `${ratio * 100}%`;
          let active = -1;
          this.weeks.forEach((week, index) => {
            if (week.getBoundingClientRect().top < focus) active = index;
          });
          const finished = ratio >= 0.98;
          this.classList.toggle('is-finished', finished);
          this.weeks.forEach((week, index) => {
            week.classList.toggle('is-complete', index < active);
            week.classList.toggle('is-active', index === active && !finished);
          });
        });
      }
    }
    customElements.define('nt-timeline', NtTimeline);
  }

  if (!customElements.get('nt-sticky-buy')) {
    class NtStickyBuy extends HTMLElement {
      connectedCallback() {
        if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", () => this.connectedCallback(), { once: true }); return; }
        const target = document.querySelector('.product-details add-to-cart-component, .product-details .add-to-cart-button, .product-details [name="add"]');
        this.querySelector('[data-nt-buy]')?.addEventListener('click', (event) => {
          event.preventDefault();
          (target || document.querySelector('#shinsei-bundle'))?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        if (!target || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this.observer = new IntersectionObserver(([entry]) => {
          const above = entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', !entry.isIntersecting && above);
        });
        this.observer.observe(target);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
    customElements.define('nt-sticky-buy', NtStickyBuy);
  }

  /* Página sempre abre no topo: o navegador não restaura a posição anterior e nenhum #âncora no endereço é seguido */
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  if (location.hash) history.replaceState(null, '', location.pathname + location.search);
  (() => {
    const reset = () => { window.scrollTo(0, 0); document.querySelector('.page-wrapper')?.scrollTo(0, 0); };
    reset(); window.addEventListener('load', reset, { once: true }); window.addEventListener('pageshow', reset); setTimeout(reset, 300);
  })();
  if (!window.ntScrollLinks) {
    window.ntScrollLinks = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.nt-section a[href^="#"]');
      if (!link) return;
      const target = document.querySelector(link.getAttribute('href')) || document.querySelector('#shinsei-bundle, #MainContent');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
